import React, { useState } from 'react'

import clsx from 'clsx'

import Button from 'components/Button'
import Icon from 'components/Icon'
import Link from 'components/Link'
import Paper from 'components/Paper'
import Typography from 'components/Typography'
import UnorderedItem from 'components/UnorderedItem'
import { useAppContext } from 'context/AppContext'
import { useEventContext } from 'context/EventContext'

import classes from './FreeAlternatives.module.scss'

const FreeAlternatives = ({ top }) => {
  const { userAgent: { isBot } = {} } = useAppContext()
  const [isExpanded, setIsExpanded] = useState(isBot)
  const { addEvent } = useEventContext({})

  const getItems = () => {
    const items = []
    const itemsLength = top.length
    const itemsNumber = isExpanded || itemsLength < 5 ? itemsLength : 5
    for (let i = 0; i < itemsNumber; i++) {
      const app = top[i]
      items.push(
        <UnorderedItem key={app.app_name}>
          <Link
            href={app.href}
            target="_self"
            {...addEvent({
              engagementComponent: 'product_alternatives_summary',
              engagementDestination: 'go-to_product_details',
              engagementDetails: 'text-link_product-name_top-alternatives',
              name: 'engagement_product_click',
              productClickUUID: app.global_product_id,
            })}
            variant="body-xs"
          >
            {app.app_name}
          </Link>
        </UnorderedItem>
      )
    }
    return items
  }

  return (
    <Paper className={clsx('FreeAlternatives', classes.root)}>
      <Typography component="h2" className={classes.title} variant="heading-xs">
        Top {top.length} free alternatives
      </Typography>
      <Typography className={classes.list} component="ul" variant="body-xs">
        {getItems()}
      </Typography>
      {top.length > 5 && (
        <Button
          variant="text"
          className={classes.expandButton}
          onClick={() => setIsExpanded(!isExpanded)}
          {...addEvent({
            engagementComponent: 'product_alternatives_summary',
            engagementDestination: isExpanded ? 'collapse' : 'expand',
            engagementDetails: `text-link_${isExpanded ? 'collapse' : 'expand'}_top-alternatives`,
            name: 'engagement_product_click',
          })}
        >
          {!isExpanded ? 'See full list' : 'See less'}{' '}
          <Icon className={isExpanded && classes.expanded} icon={['far', 'chevron-down']} size={16} />
        </Button>
      )}
    </Paper>
  )
}

export default FreeAlternatives
